"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedDuration = _interopRequireDefault(require("I18n/components/FormattedDuration"));

var _Reviewability = require("../../../constants/Reviewability");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _AppReviewability = _interopRequireDefault(require("../../../records/AppReviewability"));

var _urls = require("../../../utils/urls");

var _ExistingPortalReviewsPanel = _interopRequireDefault(require("./ExistingPortalReviewsPanel"));

var textPath = 'appMarketplace.detail.reviews';

var WriteReviewButton = function WriteReviewButton(_ref) {
  var disabled = _ref.disabled,
      offeringId = _ref.offeringId,
      onClick = _ref.onClick,
      reviewability = _ref.reviewability,
      size = _ref.size,
      tooltipPlacement = _ref.tooltipPlacement,
      use = _ref.use;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      panelOpen = _useState2[0],
      setPanelOpen = _useState2[1];

  var isReviewable = reviewability.isReviewable();
  var reason = reviewability.getUnreviewableReason();
  var tooltipMessage = (0, _react.useMemo)(function () {
    var reasonTextPath = textPath + ".write.unreviewable." + reason;

    switch (reason) {
      case _Reviewability.UnreviewableReasons.NOT_INSTALLED:
        {
          return _react.default.createElement(_FormattedJSXMessage.default, {
            message: reasonTextPath + "_jsx",
            options: {
              external: true,
              href: (0, _urls.getConnectedAppsUrl)(true)
            },
            elements: {
              Link: _UILink.default
            }
          });
        }

      case _Reviewability.UnreviewableReasons.UNINSTALLED:
        {
          return _react.default.createElement(_FormattedJSXMessage.default, {
            message: reasonTextPath + "_jsx",
            elements: {
              UninstallWindow: _react.default.createElement(_FormattedDuration.default, {
                from: 1,
                to: reviewability.get('maxMillisAfterUninstall')
              })
            }
          });
        }

      case _Reviewability.UnreviewableReasons.LIMIT_REACHED:
        {
          return _react.default.createElement(_FormattedJSXMessage.default, {
            message: reasonTextPath + "_jsx",
            options: {
              onClick: function onClick() {
                return setPanelOpen(true);
              }
            },
            elements: {
              Link: _UILink.default
            }
          });
        }

      default:
        return _react.default.createElement(_FormattedMessage.default, {
          message: reasonTextPath
        });
    }
  }, [reviewability, reason]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UITooltip.default, {
    title: tooltipMessage,
    disabled: isReviewable,
    placement: tooltipPlacement
  }, _react.default.createElement(_UIButton.default, {
    onClick: onClick,
    use: use,
    size: size,
    disabled: disabled || !isReviewable
  }, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".write.button"
  }))), panelOpen && _react.default.createElement(_ExistingPortalReviewsPanel.default, {
    offeringId: offeringId,
    onClose: function onClose() {
      return setPanelOpen(false);
    },
    portalId: _PortalIdParser.default.get(),
    reviewability: reviewability
  }));
};

WriteReviewButton.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  offeringId: _propTypes.default.number.isRequired,
  onClick: _propTypes.default.func.isRequired,
  reviewability: _propTypes.default.instanceOf(_AppReviewability.default).isRequired,
  size: _propTypes.default.string,
  tooltipPlacement: _propTypes.default.string,
  use: _propTypes.default.string
};
WriteReviewButton.defaultProps = {
  disabled: false,
  size: 'sm',
  tooltipPlacement: 'left',
  use: 'tertiary'
};
var _default = WriteReviewButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/WriteReviewButton.js
// module id = 289
// module chunks = 209 210 211 212